import { FC, isValidElement, cloneElement, ReactNode } from 'react';
import { GroupProps } from './types';
import { WbDisclosureProps } from './WbDisclosure';
import { useElementFilter } from '@mainstage/core-plugin-api';

export interface WbDisclosureStackProps {
  children?: ReactNode;
}

export const WbDisclosureStack: FC<WbDisclosureStackProps> = ({ children }) => {
  const members = useElementFilter(children, el => el.getElements());

  // Keep card z-indices local to this stack: sibling shadows can overlap,
  // but the cards cannot rise above unrelated overlays such as drawers and elements which should be higher on the interface.
  return (
    <div style={{ isolation: 'isolate' }}>
      {members.map((member, index) => {
        if (!isValidElement<WbDisclosureProps>(member)) {
          throw new Error(
            'WbDisclosureStack can only accept WbDisclosure children',
          );
        }

        let status: GroupProps['status'] = 'single';
        if (members.length > 1) {
          if (index === 0) status = 'first';
          else if (index === members.length - 1) status = 'last';
          else status = 'in-between';
        }

        const groupProps: GroupProps = {
          status,
          zIndex: members.length - index,
        };

        return cloneElement(member, {
          groupProps,
        });
      })}
    </div>
  );
};
